import OT from '@opentok/client';
import { CHAT_ENDPOINTS, CHAT_SERVER } from '../servers';
import { postRequest } from '../commService';
import { postMessage } from '../messageService';

class VideoMonitorService {
  constructor() {
    this.session = null;
    this.cameraPublisher = null;
    this.publisherScreenRec = null;
    this.sessionId = null;
    this.token = null;
    this.APIKey = null;
    this.screenRecording = null;
    this.archiveId = null;
    this.activityContext = null;
  }

  handleError = (error) => {
    if (error) throw new Error(error);
  };

  connectToSession = () => new Promise((resolve, reject) => {
    this.session.connect(this.token, (error) => {
      if (error) reject(error);
      else resolve();
    });
  });

  screenRecordingHelper = async () => {
    try {
      this.publisherScreenRec = await OT.initPublisher(
        'screenRecordPublisher',
        {
          name: 'screenRecordPublisher',
          insertMode: 'replace',
          width: '100%',
          height: '100%',
          videoSource: 'screen',
          publishAudio: false,
          publishVideo: true,
        },
        () => {
          if (this.archiveId) postMessage('archiveIdWasCreated');
          else this.screenRecording = true;
        },
      );
    } catch (error) {
      console.error('Error capturing screen:', error);
    }
  };

  createMirrorSession = async () => {
    const response = await postRequest(
      CHAT_SERVER,
      CHAT_ENDPOINTS.START_ACTIVITY_SESSION,
    );

    this.APIKey = response.body.apiKey;
    this.token = response.body.token;
    this.sessionId = response.body.sessionId;
  };

  connectToMirrorSession = async (withScreenRecording = true) => {
    if (this.sessionId && this.session) return;
    if (!this.sessionId) await this.createMirrorSession();

    this.session = await OT.initSession(this.APIKey, this.sessionId);
    this.cameraPublisher = await OT.initPublisher('publisher', {
      publishAudio: true,
      publishVideo: true,
      name: 'publisher',
      insertMode: 'replace',
      width: '100%',
      height: '100%',
      showControls: false,
    });
    if (withScreenRecording) await this.screenRecordingHelper();
    await this.connectToSession();
    this.session.publish(this.cameraPublisher);
    if (withScreenRecording) this.session.publish(this.publisherScreenRec);
  };

  startVideoMonitorRecording = async (activityContext) => {
    try {
      if (activityContext) this.activityContext = activityContext;
      await this.connectToMirrorSession(true);
      const response = await postRequest(
        CHAT_SERVER,
        CHAT_ENDPOINTS.START_ACTIVITY_ARCHIVE,
        { sessionId: this.sessionId, activityContext: this.activityContext },
      );

      this.archiveId = response.body.archiveId;
      if (this.screenRecording) {
        postMessage('archiveIdWasCreated');
        this.screenRecording = null;
      }
    } catch (error) {
      this.handleError(error);
    }
  };

  stopVideoMonitorRecording = async () => {
    try {
      if (!this.archiveId) return;
      await postRequest(CHAT_SERVER, CHAT_ENDPOINTS.STOP_ACTIVITY_ARCHIVE, {
        archiveId: this.archiveId,
      });
      this.archiveId = null;
    } catch (error) {
      this.handleError(error);
    }
  };

  disconnectFromMirrorSession = async (archiveId) => {
    try {
      const activeArchiveId = this.archiveId || archiveId;
      if (this.activityContext && activeArchiveId) {
        await postRequest(CHAT_SERVER, CHAT_ENDPOINTS.END_ACTIVITY_SESSION, {
          archiveId: activeArchiveId,
          activityContext: this.activityContext,
        });
      }
      if (this.session) this.session.disconnect();
      postMessage('archiveWasStopped');
      this.archiveId = null;
      this.APIKey = null;
      this.token = null;
      this.sessionId = null;
      this.session = null;
      this.activityContext = null;
    } catch (error) {
      this.handleError(error);
    }
  };
}

export default new VideoMonitorService();